export default "__VITE_ASSET__D_ms_nqg__"